<sbnb-signup-header></sbnb-signup-header>

<div fxFlexFill fxLayoutAlign="center center" style="padding: 40px">
  <mat-spinner *ngIf="loading" [diameter]="30"></mat-spinner>

  <p class="rose-darker" *ngIf="error">{{ error }}</p>
</div>
